import React from "react";
import { Container, Row } from "reactstrap";

const About = () => {
  return (
    <>
      <Container className="mt-3">
        <Row>
          <p style={{ textDecoration: "underline" }}>By Jose</p>
        </Row>
      </Container>
    </>
  );
};

export default About;
